import { render, staticRenderFns } from "./RiskLocationDocumentsStep.vue?vue&type=template&id=10efdce0&"
import script from "./RiskLocationDocumentsStep.vue?vue&type=script&lang=js&"
export * from "./RiskLocationDocumentsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports